import { render, staticRenderFns } from "./CasePicturesCode.vue?vue&type=template&id=b0806f64&scoped=true"
import script from "./CasePicturesCode.vue?vue&type=script&lang=js"
export * from "./CasePicturesCode.vue?vue&type=script&lang=js"
import style0 from "./CasePicturesCode.vue?vue&type=style&index=0&id=b0806f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0806f64",
  null
  
)

export default component.exports